import React from 'react';

import { Moon, Sun, SunMoon } from 'lucide-react';

import { Select, type SelectOptionItem } from 'common/uiV3/Select';

import type { Theme } from 'common/util/theme';

const ThemeOptions: SelectOptionItem[] = [
  {
    label: (
      <Select.OptionLabel>
        <SunMoon />
        System preference
      </Select.OptionLabel>
    ),
    value: 'auto',
  },
  {
    label: (
      <Select.OptionLabel>
        <Sun />
        Light
      </Select.OptionLabel>
    ),
    value: 'light',
  },
  {
    label: (
      <Select.OptionLabel>
        <Moon />
        Dark
      </Select.OptionLabel>
    ),
    value: 'dark',
  },
];

type ThemeSelectProps = {
  value: Theme;
  onValueChange: (value: Theme) => void;
  disabled?: boolean;
};

const ThemeSelect = ({ value, onValueChange, disabled }: ThemeSelectProps) => {
  return (
    <Select
      value={value}
      options={ThemeOptions}
      onValueChange={(newValue) => onValueChange(newValue as Theme)}
      disabled={disabled}
      placeholder="Select theme"
    />
  );
};

export default ThemeSelect;
